var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useMemo, useState } from "react";
import { useIntl, FormattedMessage } from "react-intl";
import { useOkapiKy } from "@folio/stripes/core";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { Button, KeyValue, MenuSection, MessageBanner, Pane, PaneMenu, } from "@folio/stripes/components";
import { CollapseFilterPaneButton, ExpandFilterPaneButton, } from "@folio/stripes/smart-components";
import NavComponent from "../../components/NavComponent";
import TableComponent from "../../components/TableComponent";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { PostponeCheckDialog } from "../../components/periodical/PostponeCheckDialog";
import { PeriodicalCheckHistory } from "../../components/periodical/PeriodicalCheckHistory";
import { PeriodicalCheckFilters, } from "../../components/periodical/PeriodicalCheckFilters";
import { SendEnforcementDialog, } from "../../components/enforcement/SendEnforcementDialog";
import { closeCheckTask, fetchIssueInquiryPreview, fetchPeriodicalCheckTasks, postponeCheckTask, sendIssueInquiry, } from "../../api/periodicalCheckService";
import { frequencyLabelId } from "../../utils/frequencyLabel";
import { formatDate } from "../../utils/formatUtils";
import { isCountCapped } from "../../utils/exactCount";
import { formatCountSubtitle } from "../../utils/paneCount";
import { useExactTotalCount } from "../../hooks/useExactTotalCount";
import { usePageSize } from "../../hooks/usePageSize";
import { createStripesSource } from "../../utils/createStripesSource";
import { useTitleSort } from "../../hooks/useTitleSort";
import { useListErrorMessage } from "../../hooks/useListErrorMessage";
import { useVariantTitlesColumn, VARIANT_TITLES_COLUMN_WIDTH, } from "../../hooks/useVariantTitlesColumn";
import { VariantTitlesList } from "../../components/common/VariantTitlesList";
import { columnSortKeys } from "../../utils/titleSort";
var DEFAULT_FILTERS = {
    name: "",
    status: "OPEN",
    provisional: false,
};
var LIST_DEFAULT_PAGE_SIZE = 100;
var DEFAULT_SORT = { sortBy: "anchorDate", sortDir: "ASC" };
var COLUMN_WIDTHS = {
    titleName: "32%",
    variantTitles: VARIANT_TITLES_COLUMN_WIDTH,
    publisherName: "22%",
    lastIssueLabel: "12%",
    anchorDate: "14%",
    expectedIssueLabel: "10%",
    status: "10%",
};
export var PeriodicalChecksList = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var formatMessage = useIntl().formatMessage;
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    var _k = useState(DEFAULT_FILTERS), draftFilters = _k[0], setDraftFilters = _k[1];
    var _l = useState(DEFAULT_FILTERS), filters = _l[0], setFilters = _l[1];
    var _m = useState(null), selectedItem = _m[0], setSelectedItem = _m[1];
    var _o = useState(true), filterPaneIsVisible = _o[0], setFilterPaneIsVisible = _o[1];
    var _p = useState(0), pageOffset = _p[0], setPageOffset = _p[1];
    var _q = usePageSize(LIST_DEFAULT_PAGE_SIZE), pageSize = _q.pageSize, setPageSize = _q.setPageSize;
    var _r = useState(false), postponeOpen = _r[0], setPostponeOpen = _r[1];
    var _s = useState(false), inquiryOpen = _s[0], setInquiryOpen = _s[1];
    var _t = useState(false), inquiryPostponeOpen = _t[0], setInquiryPostponeOpen = _t[1];
    var _u = useState(null), feedback = _u[0], setFeedback = _u[1];
    var inquiryPreview = useQuery(["periodicalCheckInquiryPreview", selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id], function () { var _a; return fetchIssueInquiryPreview(kyInstance, (_a = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) !== null && _a !== void 0 ? _a : ""); }, { enabled: inquiryOpen && !!selectedItem }).data;
    var handleRowClick = useCallback(function (item) { return setSelectedItem(item); }, []);
    var toggleFilterPane = useCallback(function () { return setFilterPaneIsVisible(function (prev) { return !prev; }); }, []);
    var handleCloseDetail = useCallback(function () { return setSelectedItem(null); }, []);
    var handlePageSizeChange = useCallback(function (size) {
        setPageSize(size);
        setPageOffset(0);
    }, [setPageSize]);
    var handleNameChange = useCallback(function (name) {
        setDraftFilters(function (prev) { return (__assign(__assign({}, prev), { name: name })); });
    }, []);
    var handleStatusChange = useCallback(function (status) {
        setDraftFilters(function (prev) { return (__assign(__assign({}, prev), { status: status })); });
    }, []);
    var handleProvisionalChange = useCallback(function (provisional) {
        setDraftFilters(function (prev) { return (__assign(__assign({}, prev), { provisional: provisional })); });
    }, []);
    var handleApplyFilters = useCallback(function () {
        setFilters(draftFilters);
        setPageOffset(0);
        setSelectedItem(null);
    }, [draftFilters]);
    var defaultPostponeDays = (_a = inquiryPreview === null || inquiryPreview === void 0 ? void 0 : inquiryPreview.defaultPostponeDays) !== null && _a !== void 0 ? _a : ((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.checkPeriodMonths)
        ? selectedItem.checkPeriodMonths * 30
        : 180);
    var showError = useCallback(function (id) {
        return setFeedback({ type: "error", message: formatMessage({ id: id }) });
    }, [formatMessage]);
    var afterResolve = useCallback(function (successId) {
        queryClient.invalidateQueries(["periodicalCheckTasks"]);
        setFeedback({
            type: "success",
            message: formatMessage({ id: successId }),
        });
    }, [queryClient, formatMessage]);
    var postponeMutation = useMutation(function (_a) {
        var taskId = _a.taskId, days = _a.days, until = _a.until, note = _a.note;
        return postponeCheckTask(kyInstance, taskId, { days: days, until: until, note: note });
    }, {
        onSuccess: function (updated) {
            setPostponeOpen(false);
            setInquiryPostponeOpen(false);
            setSelectedItem(updated);
            afterResolve("ui-br-legaldeposits.periodicalCheck.postpone.success");
        },
        onError: function () {
            return showError("ui-br-legaldeposits.periodicalCheck.postpone.error");
        },
    });
    var closeMutation = useMutation(function (taskId) { return closeCheckTask(kyInstance, taskId, {}); }, {
        onSuccess: function () {
            handleCloseDetail();
            afterResolve("ui-br-legaldeposits.periodicalCheck.close.success");
        },
        onError: function () {
            return showError("ui-br-legaldeposits.periodicalCheck.close.error");
        },
    });
    var inquiryMutation = useMutation(function (_a) {
        var taskId = _a.taskId, form = _a.form;
        return sendIssueInquiry(kyInstance, taskId, {
            subject: form.subject,
            body: form.body,
            recipientAddress: form.recipientAddress,
            communicationType: form.communicationType,
            notes: form.notes,
            postpone: false,
        });
    }, {
        onSuccess: function (updated) {
            setInquiryOpen(false);
            setSelectedItem(updated);
            queryClient.invalidateQueries([
                "periodicalCheckCommunications",
                updated.id,
            ]);
            afterResolve("ui-br-legaldeposits.periodicalCheck.inquiry.success");
            setInquiryPostponeOpen(true);
        },
        onError: function () {
            return showError("ui-br-legaldeposits.periodicalCheck.inquiry.error");
        },
    });
    var statusLabels = useMemo(function () { return ({
        OPEN: formatMessage({
            id: "ui-br-legaldeposits.periodicalCheck.status.OPEN",
        }),
        POSTPONED: formatMessage({
            id: "ui-br-legaldeposits.periodicalCheck.status.POSTPONED",
        }),
        CLOSED: formatMessage({
            id: "ui-br-legaldeposits.periodicalCheck.status.CLOSED",
        }),
    }); }, [formatMessage]);
    var renderStatus = useCallback(function (item) {
        var label = statusLabels[item.status] || item.status;
        return item.status === "POSTPONED" && item.postponedUntil
            ? "".concat(label, " (").concat(formatDate(item.postponedUntil), ")")
            : label;
    }, [statusLabels]);
    var variantTitlesColumn = useVariantTitlesColumn();
    var columns = useMemo(function () { return [
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.periodicalCheck.column.title",
            }),
            key: "titleName",
            sortKey: "titleName",
            alwaysVisible: true,
            clickable: true,
            onClick: handleRowClick,
        },
        variantTitlesColumn,
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.periodicalCheck.column.publisher",
            }),
            key: "publisherName",
            sortKey: "publisherName",
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.periodicalCheck.column.lastIssue",
            }),
            key: "lastIssueLabel",
            sortKey: "lastIssueLabel",
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.periodicalCheck.column.lastReceived",
            }),
            key: "anchorDate",
            sortKey: "anchorDate",
            cellRenderer: function (item) {
                return item.anchorDate ? formatDate(item.anchorDate) : "";
            },
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.periodicalCheck.column.expectedIssue",
            }),
            key: "expectedIssueLabel",
            sortKey: "expectedIssue",
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.periodicalCheck.column.status",
            }),
            key: "status",
            cellRenderer: renderStatus,
        },
    ]; }, [formatMessage, handleRowClick, renderStatus, variantTitlesColumn]);
    var sortKeys = useMemo(function () { return columnSortKeys(columns); }, [columns]);
    var _v = useTitleSort("periodicalChecks", sortKeys, DEFAULT_SORT), sort = _v.sort, handleSort = _v.handleSort;
    var searchName = filters.name.trim() || undefined;
    var _w = useQuery([
        "periodicalCheckTasks",
        searchName,
        filters.status,
        filters.provisional,
        sort,
        pageOffset,
        pageSize,
    ], function () {
        return fetchPeriodicalCheckTasks(kyInstance, {
            search: searchName,
            status: [filters.status],
            provisional: filters.provisional || undefined,
            sortBy: sort.sortBy,
            sortDir: sort.sortDir,
            offset: pageOffset,
            limit: pageSize,
        });
    }, { keepPreviousData: true }), data = _w.data, isLoading = _w.isLoading, isFetching = _w.isFetching, isError = _w.isError, error = _w.error;
    var tasks = useMemo(function () { var _a; return (_a = data === null || data === void 0 ? void 0 : data.items) !== null && _a !== void 0 ? _a : []; }, [data === null || data === void 0 ? void 0 : data.items]);
    var totalRecordsExact = data === null || data === void 0 ? void 0 : data.totalRecordsExact;
    var exactTotalRecords = useExactTotalCount({
        queryKey: [
            "periodicalCheckTasks",
            searchName,
            filters.status,
            filters.provisional,
        ],
        fetchTotalRecords: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchPeriodicalCheckTasks(kyInstance, {
                            search: searchName,
                            status: [filters.status],
                            provisional: filters.provisional || undefined,
                            countOnly: true,
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.totalRecords];
                }
            });
        }); },
        totalRecordsExact: totalRecordsExact,
    });
    var totalRecords = (_b = exactTotalRecords !== null && exactTotalRecords !== void 0 ? exactTotalRecords : data === null || data === void 0 ? void 0 : data.totalRecords) !== null && _b !== void 0 ? _b : 0;
    var countIsCapped = isCountCapped(totalRecordsExact, exactTotalRecords);
    var errorMessage = useListErrorMessage(error);
    var handleSortAndRestartPaging = useCallback(function (sortKey) {
        setPageOffset(0);
        handleSort(sortKey);
    }, [handleSort]);
    var source = useMemo(function () {
        return createStripesSource({
            ky: null,
            data: tasks,
            totalRecords: totalRecords,
            isLoading: isLoading,
            isError: isError,
            errorMessage: errorMessage,
            isLoaded: !isLoading,
            fetchMore: function () { return setPageOffset(pageOffset + pageSize); },
            formatMessage: formatMessage,
        });
    }, [
        tasks,
        totalRecords,
        isLoading,
        isError,
        errorMessage,
        pageOffset,
        pageSize,
        formatMessage,
    ]);
    var detailActionMenu = function () { return (React.createElement(MenuSection, { label: formatMessage({ id: "ui-br-legaldeposits.action.menu.label" }), id: "periodical-check-detail-actions" },
        React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () { return setInquiryOpen(true); }, fullWidth: true },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicalCheck.action.inquiry" })),
        React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () { return setPostponeOpen(true); }, fullWidth: true },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicalCheck.action.postpone" })),
        React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () { return selectedItem && closeMutation.mutate(selectedItem.id); }, disabled: closeMutation.isLoading, fullWidth: true },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicalCheck.action.close" })))); };
    return (React.createElement(RecekPaneSet, null,
        filterPaneIsVisible && (React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                id: "ui-br-legaldeposits.pane.title.navigation",
            }), lastMenu: React.createElement(PaneMenu, null,
                React.createElement(CollapseFilterPaneButton, { onClick: toggleFilterPane })) },
            React.createElement(NavComponent, null),
            React.createElement(PeriodicalCheckFilters, { filters: draftFilters, hasUnappliedChanges: draftFilters.name !== filters.name ||
                    draftFilters.status !== filters.status ||
                    draftFilters.provisional !== filters.provisional, onNameChange: handleNameChange, onStatusChange: handleStatusChange, onProvisionalChange: handleProvisionalChange, onApplyFilters: handleApplyFilters }))),
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", firstMenu: filterPaneIsVisible ? undefined : (React.createElement(PaneMenu, null,
                React.createElement(ExpandFilterPaneButton, { onClick: toggleFilterPane }))), paneTitle: formatMessage({
                id: "ui-br-legaldeposits.navigation.periodical-checks",
            }), paneSub: formatCountSubtitle(formatMessage, totalRecords, countIsCapped) },
            feedback && (React.createElement(MessageBanner, { type: feedback.type, onExited: function () { return setFeedback(null); }, dismissible: true }, feedback.message)),
            React.createElement(TableComponent, { data: tasks, columns: columns, columnPrefsKey: "periodicalChecks", columnWidths: COLUMN_WIDTHS, pageSize: pageSize, onPageSizeChange: handlePageSizeChange, totalCount: totalRecords, onNeedMoreData: function (offset) { return setPageOffset(offset); }, resetPaginationKey: "".concat(filters.name, "|").concat(filters.status, "|").concat(filters.provisional, "|").concat(sort.sortBy, "|").concat(sort.sortDir), searchTerm: "", filterPaneIsVisible: filterPaneIsVisible, toggleFilterPane: toggleFilterPane, source: source, isFetching: isFetching, onRowClick: handleRowClick, sortBy: sort.sortBy, sortDir: sort.sortDir, onSort: handleSortAndRestartPaging, emptyMessage: isLoading
                    ? undefined
                    : formatMessage({
                        id: "ui-br-legaldeposits.periodicalCheck.empty",
                    }) })),
        selectedItem && (React.createElement(Pane, { id: "detailPane", defaultWidth: "35%", paneTitle: (_c = selectedItem.titleName) !== null && _c !== void 0 ? _c : "", onClose: handleCloseDetail, dismissible: true, actionMenu: selectedItem.status === "CLOSED" ? undefined : detailActionMenu },
            React.createElement(VariantTitlesList, { variants: selectedItem.variantTitles }),
            React.createElement(KeyValue, { label: formatMessage({
                    id: "ui-br-legaldeposits.periodicalCheck.column.publisher",
                }), value: (_d = selectedItem.publisherName) !== null && _d !== void 0 ? _d : "" }),
            React.createElement(KeyValue, { label: formatMessage({
                    id: "ui-br-legaldeposits.periodicalCheck.detail.frequency",
                }), value: selectedItem.frequency
                    ? formatMessage({
                        id: frequencyLabelId(selectedItem.frequency),
                    })
                    : "" }),
            React.createElement(KeyValue, { label: formatMessage({
                    id: "ui-br-legaldeposits.periodicalCheck.column.lastIssue",
                }), value: (_e = selectedItem.lastIssueLabel) !== null && _e !== void 0 ? _e : "" }),
            React.createElement(KeyValue, { label: formatMessage({
                    id: "ui-br-legaldeposits.periodicalCheck.column.lastReceived",
                }), value: selectedItem.anchorDate ? formatDate(selectedItem.anchorDate) : "" }),
            React.createElement(KeyValue, { label: formatMessage({
                    id: "ui-br-legaldeposits.periodicalCheck.column.expectedIssue",
                }), value: (_f = selectedItem.expectedIssueLabel) !== null && _f !== void 0 ? _f : "" }),
            React.createElement(KeyValue, { label: formatMessage({
                    id: "ui-br-legaldeposits.periodicalCheck.detail.checkPeriod",
                }), value: formatMessage({ id: "ui-br-legaldeposits.periodicalCheck.detail.months" }, { months: selectedItem.checkPeriodMonths }) }),
            React.createElement(KeyValue, { label: formatMessage({
                    id: "ui-br-legaldeposits.periodicalCheck.column.status",
                }), value: renderStatus(selectedItem) }),
            selectedItem.postponeNote && (React.createElement(KeyValue, { label: formatMessage({
                    id: "ui-br-legaldeposits.periodicalCheck.detail.postponeNote",
                }), value: selectedItem.postponeNote })),
            React.createElement(KeyValue, { label: formatMessage({
                    id: "ui-br-legaldeposits.periodicalCheck.detail.inquiryCount",
                }), value: selectedItem.inquiryCount > 0 && selectedItem.lastInquirySentAt
                    ? formatMessage({
                        id: "ui-br-legaldeposits.periodicalCheck.detail.inquirySummary",
                    }, {
                        count: selectedItem.inquiryCount,
                        date: formatDate(selectedItem.lastInquirySentAt),
                    })
                    : formatMessage({
                        id: "ui-br-legaldeposits.periodicalCheck.detail.noInquiry",
                    }) }),
            React.createElement(PeriodicalCheckHistory, { key: selectedItem.id, taskId: selectedItem.id }))),
        React.createElement(PostponeCheckDialog, { open: postponeOpen, defaultDays: defaultPostponeDays, titleName: (_g = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.titleName) !== null && _g !== void 0 ? _g : null, isLoading: postponeMutation.isLoading, onClose: function () { return setPostponeOpen(false); }, onSubmit: function (_a) {
                var days = _a.days, until = _a.until, note = _a.note;
                return selectedItem &&
                    postponeMutation.mutate({
                        taskId: selectedItem.id,
                        days: days,
                        until: until,
                        note: note,
                    });
            } }),
        React.createElement(PostponeCheckDialog, { open: inquiryPostponeOpen, defaultDays: defaultPostponeDays, titleName: (_h = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.titleName) !== null && _h !== void 0 ? _h : null, isLoading: postponeMutation.isLoading, titleMessageId: "ui-br-legaldeposits.periodicalCheck.inquiryPostpone.title", introMessageId: "ui-br-legaldeposits.periodicalCheck.inquiryPostpone.intro", cancelMessageId: "ui-br-legaldeposits.periodicalCheck.inquiryPostpone.skip", onClose: function () { return setInquiryPostponeOpen(false); }, onSubmit: function (_a) {
                var days = _a.days, until = _a.until, note = _a.note;
                return selectedItem &&
                    postponeMutation.mutate({
                        taskId: selectedItem.id,
                        days: days,
                        until: until,
                        note: note,
                    });
            } }),
        React.createElement(SendEnforcementDialog, { open: inquiryOpen, onClose: function () { return setInquiryOpen(false); }, onSubmit: function (form) {
                return selectedItem &&
                    inquiryMutation.mutate({ taskId: selectedItem.id, form: form });
            }, preview: inquiryPreview
                ? {
                    subject: inquiryPreview.subject,
                    body: inquiryPreview.body,
                    recipientAddress: (_j = inquiryPreview.recipientAddress) !== null && _j !== void 0 ? _j : "",
                    titleCount: 1,
                    contacts: inquiryPreview.contacts,
                    titles: [],
                    skipped: [],
                }
                : null, isLoading: inquiryMutation.isLoading, showTitleCount: false, dialogTitleId: "ui-br-legaldeposits.periodicalCheck.inquiry.title" })));
};
